import React, {useState, useEffect} from 'react';
import TypePokemon from './TypePokemon';
import './ShowElements.css';
import PokeApi from './PokeApi';
import './PokeCharacter.css';
import LoadingScreen from './LoadingScreen/LoadingScreen';
import './PokeApi.css';
import PointsUI from "./PointsUI/PointsUI";

const ShowElements = (props) => {

const [pokeType, setPokeType] = useState(null);
const [pokemons, setPokemons] = useState([]);
const [filteredPokemons, setFilteredPokemons] = useState({});

const typeFilter = (pokemonArray, elementsToFilter) =>  {
	return [...pokemonArray.map(pokemon => {
		for (let type of pokemon.types) {
			if (elementsToFilter.includes(type.type.name)) {
				return pokemon;
			}
		}
	})].filter(pokemon => pokemon)
}

const getType = event => {
	setPokeType([...filteredPokemons[event.currentTarget.id]]);
}

	useEffect(() => {
	const list = Array(251).fill(0).map((e, num) => `https://pokeapi.co/api/v2/pokemon/${num+1}`);
	Promise.all(list.map(url => {
		return fetch(url)
			.then(res => res.json())
			.then(res => res)
		}))
		.then(values => {
			setPokemons(values)
		});
	}, []);

useEffect(() => {
	if (pokemons.length) {
		const pokemonspecies = Array(251).fill(0).map((e, num) => `https://pokeapi.co/api/v2/pokemon-species/${num+1}`);
		Promise.all(pokemonspecies.map(url => {
			return fetch(url)
			.then(res => res.json())
			.then(res => res)
		}))
		.then(values => {
			Promise.all(values.map(pokemon => {
				return fetch(pokemon.evolution_chain.url)
				.then(res => res.json())
				.then(res => res)
			})).then(values => {
				const littlePokemonName = values.map(value => value.chain.species.name);
				const sameName = pokemons.filter(pokemon => littlePokemonName.includes(pokemon.name));
				let pokemonsFilteredByType = {
					fire : typeFilter(sameName, ["fire"]),
					water: typeFilter(sameName, ["water"]),
					grass: typeFilter(sameName, ["grass"])
				};
				setFilteredPokemons(pokemonsFilteredByType);
				props.setAllPokemons(typeFilter(sameName, ["fire", "water", "grass"]));
			})
		})	
	}
}, [pokemons])

	return(
	<div className="App1">
		<PointsUI points={props.playerPoints} />
		{ <LoadingScreen finishedState={filteredPokemons.fire} /> }
		<div className="Title">
			<img src={require(`./Images/choose-your-element.png`)} alt="pokemon element"/>
		</div>
		<div className = "PokeType">
			<div id="fire" onClick={getType}>
				<TypePokemon name="fire" picture={require(`./Images/Fire.png`)}/>
			</div>
			<div id="water" onClick={getType}>
				<TypePokemon name="water" picture={require(`./Images/Water.png`)}/>
			</div>
			<div id="grass" onClick={getType}>
				<TypePokemon name="grass" picture={require(`./Images/Grass.png`)}/>
			</div>
		</div>
      	<div className="pokemonList">
        { pokeType ? <PokeApi element={pokeType} choosePokemon={props.choosePokemon}/> : null}
      	</div>
	</div>
	);
}


export default ShowElements;